import { useMutation } from '@tanstack/react-query';
import { getQueryClientInstance } from '@/api/queries/queryClient';
import { UserProfileDto } from '@/models';
import { UserApiService } from '@/api/userProfile/UserApiService';
import { userProfileCacheKeys } from '@/api/queries/userProfile/cacheKeys';
import { useUserProfile } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/storybook/components/Toast/Toast';

const queryClient = getQueryClientInstance();

export const useUpdateUserProfile = (preventUpdate = false) => {
  const user = useUserProfile();
  const { t } = useTranslation();
  const { makeToast } = useToast();

  return useMutation({
    mutationFn: (userData: Partial<UserProfileDto>) => UserApiService.updateUser(userData, user.userId),
    onSuccess: async () => {
      if (!preventUpdate) {
        await queryClient.invalidateQueries({ queryKey: userProfileCacheKeys.fetch });
      }
    },
    onMutate: mutationData => {
      queryClient.setQueriesData({ queryKey: userProfileCacheKeys.fetch }, (prevState: UserProfileDto) => ({
        ...prevState,
        ...mutationData,
      }));
    },
    onError: () => makeToast({ content: t('main.error.errorOccurred'), appearance: 'error' }),
  });
};
